import script from "./TutorEnrollments.vue?vue&type=script&setup=true&lang=js"
export * from "./TutorEnrollments.vue?vue&type=script&setup=true&lang=js"

import "./TutorEnrollments.vue?vue&type=style&index=0&id=5b7a0a86&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b7a0a86"]])

export default __exports__